import { render } from "./AttendanceLeaveStatistic.vue?vue&type=template&id=23e5460f"
import script from "./AttendanceLeaveStatistic.vue?vue&type=script&lang=js"
export * from "./AttendanceLeaveStatistic.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__